import { useNavigate } from "react-router-dom";
import { ArrowRight, Layers3, Beaker } from "lucide-react";

/**
 * PostCheckUpsell — appears below a completed safety check result.
 * Drives users to Routine Checker (deeper analysis) and Browse (exploration).
 * Visible but not intrusive — uses subtle cream cards, not loud CTAs.
 */
export default function PostCheckUpsell() {
  const navigate = useNavigate();

  return (
    <section
      data-testid="post-check-upsell"
      className="mt-10 sm:mt-14"
    >
      <div className="text-center mb-5">
        <span className="text-[11px] uppercase tracking-[0.22em] text-ink-mute font-semibold">
          Want deeper insights?
        </span>
        <h3 className="mt-2 text-[20px] sm:text-2xl font-bold tracking-[-0.02em] text-ink">
          Take it further
        </h3>
      </div>

      <div className="grid sm:grid-cols-2 gap-3">
        <button
          type="button"
          data-testid="post-check-routine"
          onClick={() => navigate("/routine")}
          className="group flex items-center gap-4 p-4 sm:p-5 rounded-2xl bg-white border border-surface-line hover:border-ink/30 hover:shadow-md transition-all text-left"
        >
          <span className="inline-flex w-11 h-11 items-center justify-center rounded-xl bg-cream-100 border border-surface-line text-ink shrink-0">
            <Layers3 className="w-5 h-5" strokeWidth={1.6} />
          </span>
          <span className="flex-1 min-w-0">
            <span className="block text-[14.5px] font-semibold text-ink">
              Check your full routine
            </span>
            <span className="block text-[12.5px] text-ink-soft mt-0.5">
              Analyze all products together — see every pair's result in one place.
            </span>
          </span>
          <ArrowRight className="w-4 h-4 text-ink-light group-hover:translate-x-0.5 group-hover:text-ink transition-all shrink-0" />
        </button>

        <button
          type="button"
          data-testid="post-check-browse"
          onClick={() => navigate("/browse")}
          className="group flex items-center gap-4 p-4 sm:p-5 rounded-2xl bg-white border border-surface-line hover:border-ink/30 hover:shadow-md transition-all text-left"
        >
          <span className="inline-flex w-11 h-11 items-center justify-center rounded-xl bg-cream-100 border border-surface-line text-ink shrink-0">
            <Beaker className="w-5 h-5" strokeWidth={1.6} />
          </span>
          <span className="flex-1 min-w-0">
            <span className="block text-[14.5px] font-semibold text-ink">
              Browse medications × ingredients
            </span>
            <span className="block text-[12.5px] text-ink-soft mt-0.5">
              Browse the full medication × ingredient matrix.
            </span>
          </span>
          <ArrowRight className="w-4 h-4 text-ink-light group-hover:translate-x-0.5 group-hover:text-ink transition-all shrink-0" />
        </button>
      </div>
    </section>
  );
}
